import React from 'react';

import { StyleSheet, View } from 'react-native';

import { primitive } from 'styles/constants';

export const SectionDivider = () => <View style={styles.sectionDivider} />;

const styles = StyleSheet.create({
  sectionDivider: {
    borderTopColor: primitive.$blackOpacity20,
    borderTopWidth: 1,
  },
});
